import { Tooltip, Button } from "@mui/material";

export interface CustomToolbarButtonComponentProps {
    title: string;
    onClickAction: () => void;
}

// Outlined #1976D2 toolbar button (blue border and label, transparent fill),
// consistent with the other toolbar action buttons. The color is set explicitly
// because a default outlined Button renders washed-out under the MD2 theme's
// MuiButton overrides.
const toolbarButtonSx = {
    color: "#1976D2",
    borderColor: "#1976D2",
    "&:hover": {
        borderColor: "#1565C0",
        backgroundColor: "rgba(25, 118, 210, 0.04)",
    },
};

export const CustomToolbarButtonComponent = ({ title, onClickAction }: CustomToolbarButtonComponentProps) => {
    return (
        <Tooltip title={title}>
            <Button variant="outlined" onClick={onClickAction} sx={toolbarButtonSx}>
                {title}
            </Button>
        </Tooltip>
    );
};